import { render, staticRenderFns } from "./RulesList.vue?vue&type=template&id=5110f83e&scoped=true&"
import script from "./RulesList.vue?vue&type=script&lang=js&"
export * from "./RulesList.vue?vue&type=script&lang=js&"
import style0 from "./RulesList.vue?vue&type=style&index=0&id=5110f83e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5110f83e",
  null
  
)

export default component.exports
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QList,QItem,QBtn});
